// @flow
import React from 'react';
import { defaultIconProps, type IconProps, IconSvgWrapper } from './base';

const PlayIcon = (props: IconProps) => (
  <IconSvgWrapper {...props}>
    <path
      fill={props.color}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.224 12C1.224 17.94 6.06 22.776 12 22.776C17.94 22.776 22.776 17.94 22.776 12C22.776 6.06 17.94 1.224 12 1.224C6.06 1.224 1.224 6.06 1.224 12ZM2.628 12C2.628 6.828 6.828 2.628 12 2.628C17.172 2.628 21.372 6.828 21.372 12C21.372 17.172 17.172 21.372 12 21.372C6.828 21.372 2.628 17.172 2.628 12ZM8.976 7.33199V16.668C8.976 17.232 9.624 17.556 10.08 17.22L16.308 12.564C16.68 12.276 16.68 11.724 16.308 11.448L10.092 6.77999C9.624 6.43199 8.976 6.75599 8.976 7.33199ZM10.38 14.808V9.19199C10.38 9.01199 10.584 8.90399 10.728 9.01199L14.472 11.832C14.592 11.916 14.592 12.096 14.472 12.18L10.728 14.988C10.584 15.096 10.38 14.988 10.38 14.808Z"
    />
  </IconSvgWrapper>
);

PlayIcon.defaultProps = defaultIconProps;

export default PlayIcon;
